import React from "react";
import CollapsibleSection from "../CollapsibleSection";
import styles from "../ViewOptionsPanel.module.scss";

const DateRangeSection = ({
  title = "Tarih Aralığı",
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  defaultOpen = true,
}) => (
  <CollapsibleSection title={title} defaultOpen={defaultOpen}>
    <div className={styles.dateFields}>
      <div className={styles.dateField}>
        <label className={styles.dateLabel} htmlFor="vop-start-date">
          Başlangıç
        </label>
        <input
          id="vop-start-date"
          type="date"
          className={styles.dateInput}
          value={startDate || ""}
          onChange={(e) => onStartChange?.(e.target.value)}
        />
      </div>
      <div className={styles.dateField}>
        <label className={styles.dateLabel} htmlFor="vop-end-date">
          Bitiş
        </label>
        <input
          id="vop-end-date"
          type="date"
          className={styles.dateInput}
          value={endDate || ""}
          onChange={(e) => onEndChange?.(e.target.value)}
        />
      </div>
    </div>
  </CollapsibleSection>
);

export default DateRangeSection;
